import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@/shared/icons';

/**
 * 404 — anatomia EXATA do mockup error-pages.html:
 * card 420px centrado (brand 44 roxo + eico 64 sunken + code 56 + título 19 +
 * descs 13.5/12.5 + botão home full 42px roxo). Fora do ThemeProvider — literais LIGHT do DS (vars --theme-* não existem aqui).
 */
export const NotFound: React.FC = () => {
  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{ backgroundColor: '#f8fafc', fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}
    >
      <div
        className="w-full max-w-[420px] rounded-2xl text-center"
        style={{
          backgroundColor: '#ffffff',
          border: '1px solid rgba(0, 0, 0, 0.06)',
          padding: '36px 32px',
        }}
        data-testid="not-found-card"
      >
        {/* `.brand` */}
        <div
          className="w-11 h-11 rounded-xl flex items-center justify-center mx-auto text-white font-extrabold text-lg"
          style={{ backgroundColor: '#8b5cf6', marginBottom: 22 }}
        >
          T
        </div>
        {/* `.eico.gray` */}
        <div
          className="w-16 h-16 rounded-full flex items-center justify-center mx-auto"
          style={{
            backgroundColor: '#f1f5f9',
            color: '#6b7280',
            marginBottom: 18,
          }}
        >
          <Icon name="search" className="w-7 h-7" />
        </div>
        {/* `.code` */}
        <div
          className="font-extrabold tabular-nums"
          style={{ fontSize: 56, letterSpacing: '-0.03em', lineHeight: 1, color: '#1e293b', marginBottom: 8 }}
        >
          404
        </div>
        <h1
          className="font-bold"
          style={{ fontSize: 19, letterSpacing: '-0.02em', margin: '0 0 12px', color: '#1e293b' }}
        >
          Página não encontrada
        </h1>
        <p style={{ fontSize: 13.5, color: '#6b7280', margin: '0 0 6px', lineHeight: 1.6 }}>
          A página que você procura não existe ou foi removida.
        </p>
        <p style={{ fontSize: 12.5, color: '#94a3b8', margin: 0, lineHeight: 1.6 }}>
          Verifique se o endereço está correto ou volte para a página inicial.
        </p>
        {/* `.home` */}
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 w-full rounded-xl text-white font-semibold text-sm transition-colors"
          style={{ height: 42, marginTop: 22, backgroundColor: '#8b5cf6' }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#7c3aed'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#8b5cf6'; }}
          data-testid="not-found-home"
        >
          <Icon name="home" className="w-4 h-4" />
          Voltar ao Dashboard
        </Link>
      </div>
    </div>
  );
};
